"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toTitleCase = void 0;
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.slice.js");
var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var toTitleCase = exports.toTitleCase = function toTitleCase(text) {
  if (typeof text !== 'string') return '';
  return text.split(' ').map(function (word) {
    if (word[0] === "(") {
      // if a name start with ( lodash will not capitalize the second letter. This removes the parenthesis, capitalizes the letter and adds the parenthesis back in.
      return "(".concat((0, _capitalize2.default)(word.slice(1)));
    }
    return (0, _capitalize2.default)(word);
  }).join(' ');
};